<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        XXXXXX{{id}}
        <div class="card" v-if="projects[id]">
          <div class="card-block">
            <BudgetTable :projectId="id"></BudgetTable>
          </div>
          <div class="card-block">
            <Projects :projectId="id" :showCategoryFilter="false" :showNewProject="false" :showHeader="false">
            </Projects>
          </div>
          <div class="card-block z-0">
            <ProjectWorklogs :projectId="id" :showNavigation="true" :showFilters="false"></ProjectWorklogs>
          </div>
          <div class="card-block">
            <IncomingPayments :projectId="id"></IncomingPayments>
          </div>
          <div class="card-block">
            <Invoices :projectId="id"></Invoices>
          </div>
          <div class="card-block">
            <VacationPlanner :projectId="id"></VacationPlanner>
          </div>
          <div class="card-block">
            <PlannedPeriodTimeline :projectId="id"></PlannedPeriodTimeline>
          </div>
          <div class="card-block">
            <ProjectGraph class="z-0" :projectId="id" :startDate="new Date(projects[id].start_date)"
              :endDate="new Date(projects[id].end_date)"></ProjectGraph>
          </div>
          <div class="card-block">
            <ProjectGraphics class="z-0" :projectId="id"></ProjectGraphics>
          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->
  </div>
</template>
<style lang="scss" scoped>
.z-0 {
  z-index: 0;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProjectWorklogs from './ProjectWorklogs';
import IncomingPayments from './IncomingPayments';
// import {GoogleCharts} from 'google-charts';
import ProjectGraph from './ProjectGraph';
// import moment from 'moment';
import Projects from './Projects';
import VacationPlanner from './VacationPlanner';
import PlannedPeriodTimeline from './PlannedPeriodTimeline';
import Invoices from '../documents/Invoices';
import ProjectGraphics from './ProjectGraphics.vue';
import BudgetTable from './BudgetTable.vue';

export default {
  name: 'Project',
  components: {
    ProjectWorklogs,
    IncomingPayments,
    Invoices,
    ProjectGraph,
    Projects,
    VacationPlanner,
    PlannedPeriodTimeline,
    ProjectGraphics,
    BudgetTable
  },
  data: function () {
    return {
      // id: this.$route.params.id,
    };
  },
  props: {
    id: {
      type: Number,
    },
  },
  watch: {
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects']),
  },
  methods: {
  },
  mounted() {
  },
};
</script>
